<template>
	<div class="app-wrapper">
		<header-box :tel="tel" :tel2="tel2"></header-box>
		<App-main></App-main>
		<footer-box :tel="tel"></footer-box>
	</div>
</template>

<script>
import AppMain from './components/AppMain';
import headerBox from './components/header';
import footerBox from './components/footer';
	import {getMobileInfo,getPeizhiInfo} from '@/api/api'
export default {
	name: 'Layout',
	components: {
		AppMain,headerBox,footerBox
	},
	data() {
		return {
			tel:'',
			tel2:''
		};
	},
	created() {
		// this.getMobileInfo();
	},
	mounted() {
		this.getMobileInfo();
		this.getPeizhiInfo();
	},
	methods: {
		// 
		getMobileInfo(){
			getMobileInfo({}).then(res => {
				this.tel = res.data;
			})
		},
		getPeizhiInfo(){
			getPeizhiInfo({code:'kefutelphoneCode'}).then(res => {
				this.tel2 = res.data;
			})
		},
	},
};
</script>

<style lang="scss" scoped>
.app-wrapper{background-color: #F5F8F9;}

</style>



// WEBPACK FOOTER //
// src/layout/index.vue